import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { LicenseFeatureName } from "~/modules/license/models/LicenseFeatureName.enum";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

/**
 * Return true if the current user can access the dashboard page depending on his permissions and the license features
 * @returns
 */
export function canAccessDashboardPage() {
  const licenseStore = useLicenseStore();

  return (
    useAcl().can(ACLRoles.CAN_READ_DEVICE) &&
    (licenseStore.isLicenseFeatureEnabled(LicenseFeatureName.DASHBOARD_FULL) ||
      licenseStore.isLicenseFeatureEnabled(
        LicenseFeatureName.STATIC_CHART_DEVICE_STATE,
      ) ||
      licenseStore.isLicenseFeatureEnabled(
        LicenseFeatureName.STATIC_CHART_CERTIFICATE_STATE,
      ) ||
      licenseStore.isLicenseFeatureEnabled(
        LicenseFeatureName.STATIC_CHART_DEVICE_CONNECTIVITY,
      ) ||
      licenseStore.isLicenseFeatureEnabled(
        LicenseFeatureName.STATIC_CHART_FIRMWARE_DISTRIBUTION,
      ))
  );
}
